import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import * as routes from './routes'
import * as actions from './actions'

import Icon from 'react-icons-kit'
import { connect } from 'react-redux'
import Spinner from './Spinner'
import axios from 'axios'
import { ic_check_circle } from 'react-icons-kit/md/ic_check_circle'

import './Crypto.css'

class Crypto extends Component {
    state = {
        premium: false
    }
    componentDidMount(){
        this.setState({premium: this.props.premium})
        this.interval = setInterval(()=>{
                axios.get('/api/is_premium')
                .then(r => {
                    let {premium} = r.data
                    !this.state.premium && premium && setTimeout(()=>{alert('Success: Your account is now Premium.')}, 1000*1)
                    this.setState({premium})
                    premium && clearInterval(this.interval)
                    let {access_token, username} = this.props
                    this.props.updatePremiumStatus(access_token, username, premium)
                })
            },
        1000*10)
    }

    componentDidUpdate(prevProps){
        (prevProps.premium != this.props.premium) && this.setState({premium: this.props.premium})
    }
    
    componentWillUnmount(){
        clearInterval(this.interval)
    }


    render() {
        let {premium} = this.state
        return (
            <div className='crypto_container card'>
                {premium ? <Icon size={50} icon={ic_check_circle} className='status_complete' /> : <div><Spinner /></div>}
                {!premium ? <h1>Awaiting Crypto Payment</h1> : <h1>Crypto Payment Received.</h1>}
                {!premium && <h4>Make your payment through Coinbase</h4>}
                <br />
                <h3>{!premium && <Spinner />} Account Status: {premium ? '✅ Premium':'Free'}</h3>
                <br/>
                {!premium && <p>Once crypto payment is received, your account will be automatically upgraded to Premium.</p>}
                <p>If you have any issues please contact <a href="mailto:admin@candidgirls.io">admin@candidgirls.io</a></p>
                <p>Admin can be reached on forum here: <a href="https://forum.candidgirls.io/u/Taylor_Swift">Owner</a></p>
                <br/>
                { premium && <Link to={routes.HOME}>
                    <button className='custom_btn'>Take me to the videos</button>
                </Link>
                }
            </div>
        )
    }
}

const mapStateToProps = ({access_token, username, premium}) => ({access_token, username, premium})

const mapDispatchToProps = dispatch => ({
    updatePremiumStatus: (access_token, username, premium) => dispatch(actions.setLoginData(access_token, username, premium))
})


export default connect(mapStateToProps, mapDispatchToProps)(Crypto)
